var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_520_11",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_520_11)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -2,
    width: 38,
    height: 36,
    fill: "#A5A5A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_520_11",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_520_11",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListen);
export default __webpack_public_path__ + "static/media/listen.dde771092088da2e7453cd70dd741625.svg";
export { ForwardRef as ReactComponent };